<template>
  <div v-if="component">
    <PowerApp :id="componentID" v-if="isCustomTemplate"  :entrypoint="templateEntrypoint" :schema="selectedSchema" v-bind="$attrs" v-on="$listeners"/>
    <DefaultList :component="component" :id="componentID" v-bind="$attrs" v-on="$listeners" v-else />

    <protokol-floating-settings v-if="$can('settings ' + this.component.general.getRef()) && $isPlatformEnv('dev')">
      <b-button variant="dark" to="settings" :append="true">{{ $t('settings.title') }}</b-button>
      <b-button variant="dark" to="settings#workflow" :append="true">{{ $t('workflow.title') }}</b-button>
      <b-button variant="dark" v-bind="editorButtonProps" >
        <span class="editorText">{{ $t('editor') }}</span>
      </b-button>
      <b-button variant="dark" @click="showDeletedModels = true" v-if="$can('delete ' + this.component.general.getRef())">
        {{ $t('trash.title') }}
      </b-button>
    </protokol-floating-settings>

    <DeletedModels 
      v-model="showDeletedModels" 
      :component-id="componentID"
      @restored="handleModelRestored"
    />

  </div>
  <b-skeleton width="100%" height="250px" class="align-middle" animation="throb" v-else/>
</template>

<style scoped>
.controls {
  position: relative;
  padding-bottom: 20px;
}

.controls .btn {
  margin-right: 10px;
}
</style>

<script>
import DefaultList from './DefaultList'
import DeletedModels from './DeletedModels'

export default {
  components: {
    PowerApp: () => import('./ComponentView'),
    DefaultList,
    DeletedModels
  },
  props: {
    id: {
      type: String,
      default: null
    },
    entrypoint: {
      type: String,
    }
  },
  data: () => {
    return {
      component: null,
      showSidebar: false,
      showDeletedModels: false,
      selectedSchema: ''
    }
  },

  computed: {
    editorButtonProps() {
      let props = {
        to: `/component/editor/${this.componentID}?v=${this.component.settings.version}`,
        target: "_blank"
      }

      return props
    },

    isCustomTemplate() {
      return this.templateEntrypoint != ''
    },

    templateEntrypoint() {
      if (this.entrypoint == 'default') return ''
      if (this.entrypoint) return this.entrypoint

      return this.component.settings.appearance.list_entrypoint
    },

    componentID() {
      if (this.id) {
        return this.id
      }
      
      return this.$route.meta.ref
    },
  },

  async created() {
    this.component = await this.$store.dispatch("fetchComponentsSettings", this.componentID)

    // Initialize selected schema from localStorage
    const storageKey = `component_${this.componentID}_schema`
    const storedSchema = localStorage.getItem(storageKey)
    this.selectedSchema = storedSchema !== null ? storedSchema : ''

    if (!this.$can("read " + this.component.getRef())) {
        this.$bvToast.toast(this.$t('noPermissionsToRead'), {
          title: this.$t('error'),
          variant: 'danger'
        })
        return
    }
  },

  methods: {
    handleModelRestored() {
      // Emit event to refresh the main list if needed
      this.$emit('refresh')
    }
  }
}
</script>
